import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgNumber2Solid = function SvgNumber2Solid(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor",
        viewBox: "0 0 16 20"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M13.354 19.04c.94 0 1.742-.774 1.742-1.742 0-.94-.802-1.714-1.742-1.714H7.216c4.95-3.484 7.548-6.22 7.548-9.373 0-3.677-3.124-5.889-7.05-5.889-2.018 0-4.12.58-5.834 1.88-.415.304-.746.83-.746 1.41 0 .968.802 1.742 1.77 1.742.359 0 .69-.11.967-.304 1.106-.774 2.378-1.244 3.898-1.244 1.549 0 3.014.802 3.014 2.405 0 2.212-2.074 4.037-9.096 9.152-.498.36-.857.968-.857 1.631a2.06 2.06 0 0 0 2.046 2.046z",
        clipRule: "evenodd"
    })));
};

export { SvgNumber2Solid as ReactComponent };
//# sourceMappingURL=Number2Solid.svg.es.js.map
